import { useContext, useCallback, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import "../styles/pages/EditorMainPage.scss";

import { EditorMainPageProvider } from "../Editor/contexts/EditorMainPageContext";
import ValueContext from "../ContextAPi/appContext";
import { saveAssets } from "../components/Editor/saveAssets";

import {
  EditorCanvasContextMenus,
  EditorCanvasItems,
  EditorCanvasOverlays,
  EditorLeftPanelSection,
  EditorMainCanvasSection,
  EditorMainHeader,
  EditorProgressHeader,
  EditorRightPanelSection,
  EditorTimelineSection,
} from "../Editor/components/index";

import {
  useEditorAnimationLayoutSync,
  useHitAreaScaleOnImageSizeChange,
  useEditorAssetHydration,
  useEditorAutoSave,
  useEditorBannerAssetLifecycle,
  useEditorBannerMeta,
  useEditorBannerValidation,
  useEditorCanvasDimensionFromApp,
  useEditorCanvasDomEffects,
  useEditorCanvasInteractions,
  useEditorCanvasSurfaceHandlers,
  useEditorCanvasTransforms,
  useEditorClaimReferencesSync,
  useEditorDeleteFlows,
  useEditorDerivedUsageIds,
  useEditorDropHandlers,
  useEditorKeyboardShortcuts,
  useEditorLayerHelpers,
  useEditorLayerMetrics,
  useEditorMainPageContextValue,
  useEditorMainPageState,
  useEditorModuleClaims,
  useEditorModuleData,
  useEditorMountBootstrap,
  useEditorMultiSelectInteractions,
  useEditorMutationObserver,
  useEditorNavigationToasts,
  useEditorPanelExpansion,
  useEditorRefSynchronization,
  useEditorRuntimeSync,
  useEditorScrollbarInteractions,
  useEditorSelectedFontStyles,
  useEditorSelectionHandlers,
  useEditorTimelineClock,
  useEditorUndoRedo,
  useEditorVisibilityLockHandlers,
  useEditorZoomControls,
} from "../Editor/hooks/index";

import {
  applyUniqueLayerNameIfDefaultText,
  getMaxLayerNumber,
  makeLayerNameAllocator,
  syncListSelectionState,
  createEditorComponentTypeFactory,
} from "../Editor/utils/index";

import { useDisplaycolorpicker } from "../components/RightPanel/DisplaycolorPicker.js";
import ErrComponentToRender from "../Uitls/apiErrorHandling";
import { deleteModulesCanvas } from "../services/apis";
import { renderAppliedFonts, renderTheFontLink } from "./RenderFonts";
import {
  addBody,
  froalaFontAlignments,
  froalaFontStyles,
  froalaNumberList,
  image,
  objSides,
} from "../Uitls/ComponentType";

const EditorMainPage = () => {
  const location = useLocation();
  let { bannerId } = useParams();
  const appData = useContext(ValueContext);
  const { t } = useTranslation();

  let showSelection = false;
  let Xstart;
  let Ystart;

  const {
    showToastRef,
    state,
    setState,
    isAspectRatioLocked,
    setIsAspectRatioLocked,
    isInfoPanel,
    setIsInfoPanel,
    froalatoolbarTag,
    setFroalatoolbarTag,
    popUpLeft,
    SetPopupLeft,
    canvasUpdated,
    setCanvasUpdated,
    previousCanvasDimension,
    setPreviousCanvasDimension,
    isImageDropped,
    setIsImageDropped,
    rhsUpdateTrigger,
    setRhsUpdateTrigger,
    addedActionsList,
    setAddedActionsList,
    openModulesModal,
    setOpenModulesModal,
    openModulesScreen,
    setOpenModulesScreen,
    addedAnmationActionList,
    setAddedAnmationActionList,
    loadingModules,
    setLoadingModules,
    selectedPreviousId,
    setSelectedPreviousId,
    listForReDo,
    setListForReDo,
    undoFlag,
    setundoFlag,
    undoCount,
    setUndoCount,
    openTimelinePopup,
    setOpenTimelinePopup,
    undoAnimationObjFlag,
    setUndoAnimationObjFlag,
    refreshed,
    setRefreshed,
    layerLengthAtRefresh,
    setLayerLengthAtRefresh,
    refreshCompleted,
    setRefreshCompleted,
    MLRstatus,
    setMLRstatus,
    contextMenuvisbility,
    setContextMenuvisibility,
    moduleClaimsData,
    setModuleClaimsData,
    mustUseData,
    setMustUseData,
    optionalModules,
    setOptionalModules,
    mustUseDataAvailable,
    setMustUseDataAvailable,
    droppedComponentTextIds,
    setDroppedComponentTextIds,
    copyPasteContextMenuPosition,
    setCopyPasteContextMenuPosition,
    copyPropertySelected,
    setCopyPropertySelected,
    selectedProperties,
    setSelectedProperties,
    selectedPropertiesIndex,
    setSelectedPropertiesIndex,
    copyPasteContextMenuVisibility,
    setCopyPasteContextMenuVisibility,
    popUpValuesEdited,
    setPopUpValuesEdited,
    damsID,
    setDamsId,
    marker,
    setMarker,
    showModulesSection,
    setShowModulesSection,
    isNext,
    setIsNext,
    isModuleExist,
    setIsModuleExist,
    multiSelect,
    setMultiSelect,
    multiSelectedComps,
    setMultiSelectedComps,
    moduleStatuses,
    setModuleStatuses,
    refMultiselected,
    dataGraphichImgDropped,
    setDataGraphichImgDropped,
    bannerChanged,
    setBannerChanged,
    veevaModuleCardData,
    setVeevaModuleCardData,
    selectedSizeOptions,
    setSelectedSizeOptions,
    selectedBannerSize,
    setSelectedBannerSize,
    veevaDocumentNumber,
    setVeevaDocumentNumber,
    editComponent,
    setEditComponent,
    isEditorOnScrollbarItems,
    setIsEditorOnScrollbarItems,
    scrollbarItems,
    setScrollbarItems,
    canvasScrollHeight,
    setCanvasScrollHeight,
    refBannerChanged,
    oneTimeValidationDocRef,
    isOneTimeAsset,
    setIsOneTimeAsset,
    claimReferencesFootnotes,
    setClaimReferencesFoonotes,
    refClaimReferencesFootnotes,
    scrollClaimReferencesFootnotes,
    setScrollClaimReferencesFoonotes,
    refScrollClaimReferencesFootnotes,
    notUsedEditorToggle,
    setNotUsedEditorToggle,
    layerChangedOnPause,
    setLayerChangedOnPause,
    contextMenuRef,
    bannerData,
    setBannerData,
    openTimeLine,
    setOpenTimeLine,
    getAtom,
    setAtom,
    openTextWindow,
    setOpenTextWindow,
    openShapesWindow,
    setOpenShapesWindow,
    openModuleWindow,
    setOpenModuleWindow,
    openImageWindow,
    setOpenImageWindow,
    layerCompData,
    setLayerCompData,
    canvasStyleDraft,
    setCanvasStyleDraft,
    showPreview,
    setPreView,
    previewURl,
    setpreviewURl,
    previewRedirectHome,
    setPreviewRedirectHome,
    tempLayer,
    tempLayerScrollbarItems,
    editComponentRef,
    moduleSearchExpression,
    setModuleSearchExpression,
    removeSymbol,
    setRemoveSymbol,
    canvasDimension,
    setCanvasDimension,
    layerId,
    setLayerId,
    layerIndex,
    setLayerIndex,
    animationObject,
    setAnimationObject,
    animationObjRef,
    droppedComponentIds,
    setDroppedComponentIds,
    droppedTextIds,
    setDroppedTextIds,
    droppedTitleIds,
    setDroppedTitleIds,
    dimensionsData,
    setDimensionsData,
    containerID,
    setContainerID,
    currentIdZindex,
    setCurrentIdZindex,
    createFroalaInstance,
    froalaIndex,
    setFroalaIndex,
    selectedComponent,
    setSelectedComponent,
    count,
    setCount,
    compCountRef,
    isVisible,
    setVisibility,
    showPaste,
    setShowPaste,
    toggleSelected,
    setToggleSelected,
    copiedComponent,
    setCopiedComponent,
    copiedComponentRef,
    countZindex,
    setCountZindex,
    refCountZindex,
    checkedAspect,
    setCheckedAspect,
    checkedScroll,
    setCheckedScroll,
    myStateRef,
    myCanvasRef,
    modules,
    setModules,
    selectedModulecards,
    setSelectedModulecards,
    tempSelect,
    scrollBarExpand,
    editModuleClicked,
    setEditModuleClicked,
    moduleSymbol,
    setmoduleSymbol,
    bgColorCanvas,
    setBgColorCanvas,
    genericInfo,
    setGenericInfo,
    moduleCardsDataLHS,
    setModuleCardsDataLHS,
    playPause,
    setPlayPause,
    playPauseRef,
    verticalLineFor,
    setVerticalLineFor,
    addedCanvasActionsList,
    setAddedCanvasactionsList,
    canvasBgChange,
    setCanvasBgChange,
    isEditorOn,
    setIsEditorOn,
    isDragged,
    setIsDragged,
    clickedTimes,
    setClickedTimes,
    isReferenceFootnotes,
    setisReferenceFootnotes,
    isReferenceFootnotesScrollbar,
    setisReferenceFootnotesScrollbar,
    claimsArray,
    setClaimsArray,
    reusableTextIdsArray,
    setReusableTextIdsArray,
    refClaimsArray,
    refReusableTextIdsArray,
    refDroppedTextIdsArray,
    refDroppedComponentTextIds,
    refDroppedComponentIds,
    allMustUseDataEmpty,
    undoStack,
    redoStack,
    changeInEditor,
    setchangeInEditor,
    copiedKeyFrame,
    setCopiedKeyFrame,
    popUpOptions,
    setPopUpOptions,
    linkedModulesType,
    setLinkedModulesType,
    undoVersion,
    setUndoVersion,
    expanded,
    setExpanded,
    toggleAnimatedBanner,
    setToggleAnimatedBanner,
    showBannertype,
    setShowBannertype,
    showBannerName,
    setShowBannerName,
    showAssettype,
    setShowAssettype,
    bannerValidationCheck,
    setBannerValidationCheck,
    draggerWidth,
    setDraggerWidth,
    zindexDelete,
    setZindexDelete,
  } = useEditorMainPageState({ location });

  const { setDisplayColorPicker } = useDisplaycolorpicker(false);

  useEditorDerivedUsageIds({
    layerCompData,
    claimsArray,
    droppedComponentIds,
    droppedTextIds,
    reusableTextIdsArray,
    droppedTitleIds,
    setClaimsArray,
    setDroppedComponentIds,
    setDroppedTextIds,
    setReusableTextIdsArray,
    setDroppedTitleIds,
  });

  useEditorCanvasDimensionFromApp({
    appData,
    canvasDimension,
    setCanvasDimension,
  });

  const { observeMutations } = useEditorMutationObserver({
    contextMenuRef,
    setBannerChanged,
    refBannerChanged,
    setLayerChangedOnPause,
  });

  useEditorMountBootstrap({
    showToastRef,
    state,
    setIsOneTimeAsset,
    setOpenModulesModal,
    setOpenModulesScreen,
    observeMutations,
  });

  const { getLayerDetails, layerSequence } = useEditorLayerHelpers({
    setLayerId,
    tempLayer,
  });

  useEditorRefSynchronization({
    refReusableTextIdsArray,
    reusableTextIdsArray,
    refClaimsArray,
    claimsArray,
    refDroppedComponentIds,
    droppedComponentIds,
    refDroppedTextIdsArray,
    droppedTextIds,
    refDroppedComponentTextIds,
    droppedComponentTextIds,
    tempLayer,
    layerCompData,
    tempSelect,
    selectedComponent,
    refMultiselected,
    multiSelectedComps,
    animationObjRef,
    animationObject,
    compCountRef,
    count,
    copiedComponentRef,
    copiedComponent,
    refCountZindex,
    countZindex,
    setAnimationObject,
  });

  useHitAreaScaleOnImageSizeChange({
    layerCompData,
    setLayerCompData,
    selectedComponent,
    setSelectedComponent,
    setAnimationObject,
  });

  const { fetchAllSizesBanner, fetchOneTimeAssetStatus } = useEditorBannerMeta({
    bannerId,
    oneTimeValidationDocRef,
    setIsOneTimeAsset,
    setSelectedSizeOptions,
    setSelectedBannerSize,
  });

  const {
    millSeconds,
    seconds,
    setMillSeconds,
    setSeconds,
    pixelToTimeConverter,
  } = useEditorTimelineClock();

  const { handleChange } = useEditorPanelExpansion({
    expanded,
    setExpanded,
  });

  const { toggleLockComp, toggleHideComp } = useEditorVisibilityLockHandlers({
    layerCompData,
    editComponent,
    setSelectedComponent,
    setScrollbarItems,
    setLayerCompData,
    setOpenTimelinePopup,
  });

  const { sendSelectedComponent } = useEditorSelectionHandlers({
    playPauseRef,
    playPause,
    setVerticalLineFor,
    selectionGuideDefaults: objSides,
    setClickedTimes,
    setSelectedComponent,
    setLayerId,
    layerCompData,
    setLayerCompData,
    animationObject,
    setLayerIndex,
    layerIndex,
    setIsEditorOn,
    editComponent,
    scrollbarItems,
    setScrollbarItems,
  });

  const { saveBannerValidationCheckDetails } = useEditorBannerValidation({
    selectedSizeOptions,
    allMustUseDataEmpty,
    bannerId,
    setBannerValidationCheck,
    t,
    isNewBanner: state?.newBanner,
  });

  const { NavigateToLandingPage } = useEditorNavigationToasts({
    t,
    setLoadingModules,
  });

  const { getHeightestZindex, getMaxlayerNameCount } = useEditorLayerMetrics({
    layerCompData,
    layerSequence,
  });

  const { canvasScrollToggle, handleZoomIn, handleZoomOut } =
    useEditorZoomControls({
      canvasDimension,
      setCanvasDimension,
      setCanvasUpdated,
    });

  const { handleRedo, handleCanvasUndo } = useEditorUndoRedo({
    setundoFlag,
    setUndoAnimationObjFlag,
    listForReDo,
    addedActionsList,
    addedAnmationActionList,
    addedCanvasActionsList,
    setAddedActionsList,
    setAddedAnmationActionList,
    setAddedCanvasactionsList,
    setSelectedComponent,
    setLayerCompData,
    setAnimationObject,
    setOpenTimelinePopup,
    setMarker,
    SetPopupLeft,
    pixelToTimeConverter,
    setCanvasDimension,
    setCanvasBgChange,
    setListForReDo,
    setBgColorCanvas,
  });

  const { selectedFontId, setSelectedFontId, updateSelctedFontstyle } =
    useEditorSelectedFontStyles({
      selectedComponent,
      layerCompData,
      setSelectedComponent,
      setLayerCompData,
    });

  const { onDropScrollbar, onDragOverScrollbar, dropLayer } =
    useEditorDropHandlers({
      layerId,
      setLayerId,
      getAtom,
      setAtom,
      getComponentType: () => componentType,
      canvasDimension,
      droppedComponentIds,
      setDroppedComponentIds,
      image,
      addBody,
      droppedTitleIds,
      setDroppedTitleIds,
      droppedTextIds,
      setDroppedTextIds,
      setDroppedComponentTextIds,
      scrollClaimReferencesFootnotes,
      setScrollClaimReferencesFoonotes,
      claimsArray,
      setClaimsArray,
      reusableTextIdsArray,
      setReusableTextIdsArray,
      claimReferencesFootnotes,
      setClaimReferencesFoonotes,
      makeLayerNameAllocator,
      getMaxLayerNumber,
      tempLayer,
      applyUniqueLayerNameIfDefaultText,
      syncListSelectionState,
      marker,
      draggerWidth,
      layerCompData,
      setScrollbarItems,
      setLayerCompData,
      setSelectedComponent,
      count,
      setCount,
      objSides,
      setVerticalLineFor,
      setundoFlag,
      setUndoAnimationObjFlag,
      setIsEditorOn,
      setIsEditorOnScrollbarItems,
      setMultiSelectedComps,
    });

  const {
    updateCompValues,
    callOnDragStop,
    updateFontOnResize,
    callOnResizeStop,
    imageOnCanvas,
    allowDroplayer,
    handleTextChangeInLayerComp,
    handleClickOnCanvas,
  } = useEditorCanvasTransforms({
    editComponentRef,
    editComponent,
    tempLayerScrollbarItems,
    tempLayer,
    tempSelect,
    setSelectedComponent,
    isDragged,
    canvasDimension,
    createFroalaInstance,
    playPauseRef,
    setVerticalLineFor,
    verticalLineFor,
    layerCompData,
    selectedComponent,
    objSides,
    layerSequence,
    getMaxlayerNameCount,
    getHeightestZindex,
    image,
    count,
    setCountZindex,
    isAspectRatioLocked,
    setCount,
    setLayerCompData,
    setScrollbarItems,
    setIsEditorOnScrollbarItems,
    setLayerId,
    setMultiSelectedComps,
    setExpanded,
    setAnimationObject,
    draggerWidth,
  });

  const { handleDrop, handleDragOver } = useEditorCanvasSurfaceHandlers({
    editComponent,
    dropLayer,
    allowDroplayer,
  });

  const componentType = createEditorComponentTypeFactory({
    count,
    setCountZindex,
    layerSequence,
    getHeightestZindex,
    getMaxlayerNameCount,
    isAspectRatioLocked,
    canvasDimension,
    editComponent,
    imageOnCanvas,
  });

  const { checkAllMustUseData, fetchAllClaims, fetchAllChildModules } =
    useEditorModuleClaims({
      appData,
      allMustUseDataEmpty,
      setOptionalModules,
      setMustUseDataAvailable,
      setmoduleSymbol,
      setModuleStatuses,
      setLoadingModules,
    });

  const { getEditSaveAssets } = useEditorAssetHydration({
    showToastRef,
    NavigateToLandingPage,
    ErrComponentToRender,
    setLoadingModules,
    setundoFlag,
    setUndoAnimationObjFlag,
    setPreviewRedirectHome,
    setpreviewURl,
    setPreView,
    renderAppliedFonts,
    setVeevaDocumentNumber,
    fetchAllSizesBanner,
    fetchOneTimeAssetStatus,
    setGenericInfo,
    setCanvasDimension,
    appData,
    setLinkedModulesType,
    setModules,
    setToggleAnimatedBanner,
    setShowBannertype,
    setShowAssettype,
    setShowBannerName,
    setBannerData,
    setDamsId,
    setMLRstatus,
    setIsModuleExist,
    setModuleCardsDataLHS,
    isOneTimeAsset,
    fetchAllChildModules,
    fetchAllClaims,
    setModuleSearchExpression,
    editModuleClicked,
    imageOnCanvas,
    componentType,
    setLayerLengthAtRefresh,
    setRefreshed,
    setLayerCompData,
    setSelectedComponent,
    setAnimationObject,
    setDroppedTextIds,
    setDroppedComponentIds,
    setDroppedTitleIds,
    setReusableTextIdsArray,
    setClaimReferencesFoonotes,
    setScrollClaimReferencesFoonotes,
    setClaimsArray,
    setCount,
    setRefreshCompleted,
    setIsOneTimeAsset,
    setDraggerWidth,
  });

  useEditorBannerAssetLifecycle({
    bannerId,
    getEditSaveAssets,
  });

  const persistBannerCanvas = useCallback(
    (overrides = {}) => {
      const assetId = appData?.assetInfo?.assetId || bannerId;
      if (!assetId) return Promise.resolve(false);

      return saveAssets({
        layerCompData: overrides.layerCompData ?? layerCompData,
        assetId,
        animationObject: overrides.animationObject ?? animationObject,
        setLayerCompData,
        setundoFlag,
        bannerChanged,
        refBannerChanged,
        setBannerChanged,
        setRefreshed,
        origin: overrides.origin ?? "hitAreaSave",
        bannerName: appData?.assetInfo?.assetName || showBannerName,
        setShowBannerName,
      });
    },
    [
      animationObject,
      appData?.assetInfo?.assetId,
      appData?.assetInfo?.assetName,
      bannerChanged,
      bannerId,
      layerCompData,
      refBannerChanged,
      setBannerChanged,
      setLayerCompData,
      setRefreshed,
      setShowBannerName,
      setundoFlag,
      showBannerName,
    ]
  );

  useEditorAutoSave({
    persistBannerCanvas,
    bannerChanged,
    refBannerChanged,
    setBannerChanged,
    layerCompData,
    animationObject,
    bannerId,
    refreshCompleted,
    tempLayer,
    animationObjRef,
  });

  const {
    deleteComponentOnCanvas,
    handleDeleteKeyScrollbarComponent,
    handleDeleteKey,
  } = useEditorDeleteFlows({
    playPauseRef,
    selectedComponent,
    refMultiselected,
    editComponentRef,
    refClaimsArray,
    refDroppedComponentIds,
    refDroppedTextIdsArray,
    refClaimReferencesFootnotes,
    setDroppedTitleIds,
    setOpenTimelinePopup,
    tempLayer,
    setLayerCompData,
    setMultiSelectedComps,
    animationObjRef,
    setAnimationObject,
    setSeconds,
    setMillSeconds,
    setSelectedComponent,
    setVisibility,
    setClaimsArray,
    setClaimReferencesFoonotes,
    setDroppedComponentIds,
    setDroppedTextIds,
    editComponent,
    refReusableTextIdsArray,
    setReusableTextIdsArray,
    refDroppedComponentTextIds,
    layerCompData,
    setScrollbarItems,
    setContextMenuvisibility,
    refScrollClaimReferencesFootnotes,
    setScrollClaimReferencesFoonotes,
    tempSelect,
    tempLayerScrollbarItems,
  });

  useEditorKeyboardShortcuts({
    bannerId,
    tempSelect,
    updateCompValues,
    setVerticalLineFor,
    compCountRef,
    setCount,
    setShowPaste,
    setVisibility,
    tempLayer,
    setLayerCompData,
    copiedComponentRef,
    refCountZindex,
    refMultiselected,
    setMultiSelectedComps,
    setCopiedComponent,
    componentType,
    imageOnCanvas,
    setSelectedComponent,
    playPauseRef,
    handleDeleteKey,
  });

  const { froalaEditorHandleOnclciksAndDrag, clearFroalaTextSelection } =
    useEditorCanvasDomEffects({
      setVisibility,
      setShowPaste,
      layerCompData,
      createFroalaInstance,
      isEditorOn,
      setIsEditorOn,
    });

  const {
    updatedValue,
    setUpdatedValue,
    multiSelectedComponent,
    setMultiSelectedComponent,
    updateMultiCompProperties,
    handleCtrlClick,
    handleComponentsDrag,
    handleComponentsDragStop,
    isMultiSelectComponentVisible,
  } = useEditorMultiSelectInteractions({
    playPause,
    editComponent,
    multiSelectedComps,
    setMultiSelectedComps,
    selectedComponent,
    setSelectedComponent,
    layerCompData,
    setLayerCompData,
    setisReferenceFootnotes,
    updateCompValues,
    callOnDragStop,
  });

  const { ToggleAspectLock } = useEditorRuntimeSync({
    changeInEditor,
    setUpdatedValue,
    selectedComponent,
    playPause,
    playPauseRef,
    myStateRef,
    setCheckedAspect,
  });

  const {
    getScrollbarItems,
    handleScrollbarComponentsDrag,
    handleScrollbarComponentsDragStop,
    handleTextChangeInScrollComp,
    handleCallonResizeStop,
    handleCallonResize,
    isScrollbarRhsEnable,
    onScrollbarComponentResizeStop,
    onScrollbarComponentsResize,
  } = useEditorScrollbarInteractions({
    editComponent,
    setLayerCompData,
    layerCompData,
    setScrollbarItems,
    selectedComponent,
    setSelectedComponent,
    setUpdatedValue,
    tempLayerScrollbarItems,
    scrollbarItems,
    setisReferenceFootnotesScrollbar,
    setCanvasScrollHeight,
    canvasDimension,
    setEditComponent,
    callOnResizeStop,
    updateFontOnResize,
  });

  useEditorClaimReferencesSync({
    layerCompData,
    setLayerCompData,
    claimReferencesFootnotes,
    scrollClaimReferencesFootnotes,
    claimsArray,
    refClaimReferencesFootnotes,
    refScrollClaimReferencesFootnotes,
  });

  const { handleChangeSizeRefereshModulesData, deleteModulesOnCanvas } =
    useEditorModuleData({
      claimsArray,
      reusableTextIdsArray,
      droppedComponentIds,
      droppedTextIds,
      mustUseDataAvailable,
      droppedTitleIds,
      optionalModules,
      layerCompData,
      checkAllMustUseData,
      setMustUseData,
      setClaimsArray,
      setDroppedComponentIds,
      setDroppedComponentTextIds,
      setDroppedTextIds,
      setClaimReferencesFoonotes,
      setScrollClaimReferencesFoonotes,
      setNotUsedEditorToggle,
      veevaDocumentNumber,
      selectedSizeOptions,
      saveBannerValidationCheckDetails,
      setEditModuleClicked,
      deleteModulesCanvas,
      ErrComponentToRender,
    });

  const { copyCanvasComponent, pasteComponentOnCanvas, updateZindexValue } =
    useEditorCanvasInteractions({
      multiSelectedComps,
      setCopiedComponent,
      editComponent,
      tempLayerScrollbarItems,
      tempLayer,
      tempSelect,
      setVisibility,
      layerCompData,
      setCount,
      setShowPaste,
      setLayerCompData,
      copiedComponent,
      count,
      countZindex,
      setMultiSelectedComps,
      imageOnCanvas,
      setSelectedComponent,
      selectedComponent,
      setScrollbarItems,
      selectedComponentState: selectedComponent,
      containerID,
    });

  const observeMutationsRef = useRef(observeMutations);
  const hasCanvasDimensions =
    Number(canvasDimension?.width) > 0 && Number(canvasDimension?.height) > 0;
  const isBannerCanvasLoading = loadingModules || !hasCanvasDimensions;

  useEffect(() => {
    observeMutationsRef.current = observeMutations;
  }, [observeMutations]);

  useEffect(() => {
    if (!isBannerCanvasLoading) {
      observeMutationsRef.current();
    }
  }, [isBannerCanvasLoading]);

  const editorMainPageContextValue = useEditorMainPageContextValue({
    openTimeLine,
    getEditSaveAssets,
    persistBannerCanvas,
    setIsOneTimeAsset,
    isOneTimeAsset,
    setBannerValidationCheck,
    allMustUseDataEmpty,
    removeSymbol,
    setRemoveSymbol,
    bannerValidationCheck,
    saveBannerValidationCheckDetails,
    undoStack,
    redoStack,
    setUndoVersion,
    undoVersion,
    rhsUpdateTrigger,
    moduleSymbol,
    setmoduleSymbol,
    mustUseData,
    setEditModuleClicked,
    handleChangeSizeRefereshModulesData,
    setMLRstatus,
    setDamsId,
    handleZoomIn,
    handleZoomOut,
    selectedComponent,
    popUpOptions,
    setCount,
    renderAppliedFonts,
    addedActionsList,
    refreshed,
    layerLengthAtRefresh,
    addedCanvasActionsList,
    handleCanvasUndo,
    listForReDo,
    handleRedo,
    setundoFlag,
    undoCount,
    setPlayPause,
    bannerChanged,
    refBannerChanged,
    setBannerChanged,
    setRefreshed,
    showBannertype,
    showBannerName,
    setShowBannerName,
    showAssettype,
    linkedModulesType,
    selectedSizeOptions,
    selectedBannerSize,
    setMultiSelectedComponent,
    setBgColorCanvas,
    setCanvasDimension,
    setchangeInEditor,
    changeInEditor,
    showPreview,
    setPreView,
    previewURl,
    setpreviewURl,
    previewRedirectHome,
    setPreviewRedirectHome,
    claimReferencesFootnotes,
    setClaimReferencesFoonotes,
    setState,
    moduleStatuses,
    setModuleStatuses,
    deleteModulesOnCanvas,
    notUsedEditorToggle,
    setNotUsedEditorToggle,
    setDroppedTextIds,
    setDroppedComponentIds,
    setDroppedComponentTextIds,
    setScrollClaimReferencesFoonotes,
    setClaimsArray,
    reusableTextIdsArray,
    claimsArray,
    isReferenceFootnotes,
    isReferenceFootnotesScrollbar,
    editComponent,
    droppedTextIds,
    droppedTitleIds,
    setDroppedTitleIds,
    droppedComponentIds,
    setModuleClaimsData,
    moduleClaimsData,
    setDataGraphichImgDropped,
    dataGraphichImgDropped,
    moduleSearchExpression,
    setModuleSearchExpression,
    setSelectedModulecards,
    selectedModulecards,
    setModuleCardsDataLHS,
    moduleCardsDataLHS,
    bannerId,
    isModuleExist,
    setIsModuleExist,
    isNext,
    setIsNext,
    showModulesSection,
    setShowModulesSection,
    setOpenModulesModal,
    openModulesScreen,
    setOpenModulesScreen,
    openModulesModal,
    setModules,
    modules,
    openTextWindow,
    setOpenTextWindow,
    openModuleWindow,
    setOpenModuleWindow,
    getLayerDetails,
    layerId,
    openShapesWindow,
    setOpenShapesWindow,
    setOpenTimeLine,
    setAtom,
    setOpenImageWindow,
    openImageWindow,
    imageOnCanvas,
    setLinkedModulesType,
    loadingModules,
    setLoadingModules,
    setVeevaModuleCardData,
    veevaModuleCardData,
    toggleHideComp,
    toggleLockComp,
    isImageDropped,
    setIsImageDropped,
    tempLayerScrollbarItems,
    editComponentRef,
    setEditComponent,
    setIsEditorOnScrollbarItems,
    setMultiSelectedComps,
    isAspectRatioLocked,
    handleComponentsDrag,
    handleComponentsDragStop,
    getScrollbarItems,
    setToggleSelected,
    handleClickOnCanvas,
    setVisibility,
    clearFroalaTextSelection,
    setSelectedComponent,
    onScrollbarComponentResizeStop,
    onScrollbarComponentsResize,
    handleDeleteKey,
    multiSelectedComps,
    toggleAnimatedBanner,
    onDropScrollbar,
    layerCompData,
    setLayerCompData,
    canvasStyleDraft,
    setCanvasStyleDraft,
    setContextMenuvisibility,
    contextMenuvisbility,
    deleteComponentOnCanvas,
    draggerWidth,
    setDraggerWidth,
    onDragOverScrollbar,
    setScrollbarItems,
    isEditorOnScrollbarItems,
    isDragged,
    froalaEditorHandleOnclciksAndDrag,
    setFroalaIndex,
    setContainerID,
    createFroalaInstance,
    handleScrollbarComponentsDrag,
    handleScrollbarComponentsDragStop,
    handleCallonResizeStop,
    setCurrentIdZindex,
    sendSelectedComponent,
    layerIndex,
    playPauseRef,
    handleCallonResize,
    handleTextChangeInScrollComp,
    handleCtrlClick,
    scrollBarExpand,
    setRhsUpdateTrigger,
    updateMultiCompProperties,
    updatedValue,
    setUpdatedValue,
    setIsAspectRatioLocked,
    MLRstatus,
    damsID,
    isInfoPanel,
    selectedFontId,
    setSelectedFontId,
    updateSelctedFontstyle,
    setFroalatoolbarTag,
    genericInfo,
    setGenericInfo,
    myCanvasRef,
    dimensionsData,
    isScrollbarRhsEnable,
    froalaFontAlignments,
    froalaNumberList,
    froalaFontStyles,
    toggleSelected,
    checkedAspect,
    ToggleAspectLock,
    expanded,
    setExpanded,
    handleChange,
    setCheckedScroll,
    checkedScroll,
    renderTheFontLink,
    setSelectedPreviousId,
    canvasUpdated,
    setCanvasUpdated,
    previousCanvasDimension,
    setPreviousCanvasDimension,
    bgColorCanvas,
    canvasBgChange,
    setCanvasBgChange,
    setOpenTimelinePopup,
    setClickedTimes,
    setZindexDelete,
    updateZindexValue,
    handleDeleteKeyScrollbarComponent,
    isVisible,
    copiedComponent,
    copyCanvasComponent,
    pasteComponentOnCanvas,
    setShowPaste,
    componentType,
    showPaste,
    setDisplayColorPicker,
    showSelection,
    Xstart,
    Ystart,
    setMultiSelect,
    tempLayer,
    multiSelect,
    canvasScrollToggle,
    canvasScrollHeight,
    handleDrop,
    handleDragOver,
    isEditorOn,
    setIsEditorOn,
    updateFontOnResize,
    callOnResizeStop,
    handleTextChangeInLayerComp,
    contextMenuRef,
    verticalLineFor,
    setVerticalLineFor,
    isMultiSelectComponentVisible,
    playPause,
    multiSelectedComponent,
    canvasDimension,
    animationObject,
    setAnimationObject,
    millSeconds,
    seconds,
    setMillSeconds,
    setSeconds,
    copiedKeyFrame,
    setCopiedKeyFrame,
    setPopUpOptions,
    openTimelinePopup,
    popUpValuesEdited,
    setPopUpValuesEdited,
    marker,
    setMarker,
    popUpLeft,
    SetPopupLeft,
    clickedTimes,
    froalaIndex,
    layerChangedOnPause,
    setLayerChangedOnPause,
    setSelectedProperties,
    selectedProperties,
    setSelectedPropertiesIndex,
    selectedPropertiesIndex,
    setCopyPropertySelected,
    copyPropertySelected,
    setCopyPasteContextMenuPosition,
    copyPasteContextMenuPosition,
    setCopyPasteContextMenuVisibility,
    copyPasteContextMenuVisibility,
  });
 
  return (
    <EditorMainPageProvider value={editorMainPageContextValue}>
      <EditorMainHeader />

      <div className="container-fluid">
        <div className="editormainPage">
          <Row className="editorRow">
            {loadingModules && (
              <>
                <div className="modal-backdrop fade show"> </div>
              </>
            )}
            <Col
              className="col-9 col-md-9"
              style={{ backgroundColor: "#eff4f7" }}
            >
              <Row style={{ backgroundColor: "#eff4f7" }}>
                <Col className="col-1 col-md-1 leftHandSide">
                  <EditorLeftPanelSection />
                </Col>

                <Col className=" col-11 col-md-11 editorCol ">
                  {isBannerCanvasLoading ? (
                    <div
                      id="mainCanvasContainer"
                      className="canvasUnset canvasCol-dup canvasCol mt-0"
                      style={{
                        backgroundColor: "#eff4f7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "50vh",
                      }}
                    >
                      <CircularProgress size="30px" className="customLoader" />
                    </div>
                  ) : (
                    <>
                      <EditorProgressHeader />

                      <EditorMainCanvasSection key={bannerId}>
                        <EditorCanvasOverlays />
                        <EditorCanvasItems />
                      </EditorMainCanvasSection>

                      <EditorCanvasContextMenus />
                    </>
                  )}
                </Col>
              </Row>

              <div class="row">
                <div className="col-12 col-md-12 px-0">
                  <div className="timeLinePanel"></div>
                  <EditorTimelineSection />
                </div>
              </div>
            </Col>

            <Col className=" col-3 col-md-3 rightHandside">
              <div className="rightpn">
                <EditorRightPanelSection />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </EditorMainPageProvider>
  );
};

export default EditorMainPage;

